import React from 'react';
import { CircularProgress } from '@mui/material';
import { useThemeMode } from '../theme';

const Loader = () => {
    const { colours } = useThemeMode();
    
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <CircularProgress style={{ color: colours.primary100 }} />
        </div>
    )
}

export default Loader;